module.exports = __webpack_public_path__ + "static/media/german_artillery_120.51a61ea6.png";